import { NgModule, Optional, SkipSelf } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../shared/shared.module";
import { GuidelinesRoutingModule } from "./guidelines-routing.module";
import { EnsureModuleLoadedOnceGuard } from "../../../../shared-lib/src/public-api";
import { GuidelineComponent } from "./guideline/guideline.component";

@NgModule({
  declarations: [GuidelinesRoutingModule.components, GuidelineComponent],
  imports: [GuidelinesRoutingModule, CommonModule, SharedModule],
})
export class GuidelinesModule extends EnsureModuleLoadedOnceGuard {
  // Ensure that PathwaysModule is only loaded into AppModule
  // Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
  constructor(@Optional() @SkipSelf() parentModule: GuidelinesModule) {
    super(parentModule);
  }
}
